(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bisous-installments"] && !Shopify.designMode) return;
  try {
    /* Horizon ne morphe que le variant-picker : on va chercher la valeur fraîche
     dans le document renvoyé par le fetch, porté par variant:update. */
  document.addEventListener('variant:update', function (event) {
    var detail = event && event.detail;
    var doc = detail && detail.data && detail.data.html;
    if (!doc) return;
    var scope = event.target && event.target.closest ? event.target.closest('.shopify-section') : null;
    var nodes = (scope || document).querySelectorAll('[data-bs-pay4]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var id = el.getAttribute('data-bs-pay4-id');
      var fresh = doc.querySelector('[data-bs-pay4][data-bs-pay4-id="' + id + '"]');
      if (!fresh) continue;
      el.innerHTML = fresh.innerHTML;
      el.hidden = fresh.hasAttribute('hidden');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
